import { ReactNode } from "react";
import { Icon } from "dash-ui";

interface LockedOverlayProps {
  message?: string;
  iconSize?: number;
  children?: ReactNode;
}

const LockedOverlay = ({
  message = "Subscribe to unlock this property",
  iconSize = 36,
  children,
}: LockedOverlayProps) => (
  <>
    <div
      className="w-full h-full bg-gray-900 absolute z-20 opacity-70 rounded-md"
      aria-hidden="true"
    ></div>
    <div className="flex flex-col w-full h-full absolute z-30 justify-center items-center">
      <div className="justify-center items-center">
        <Icon name="lock" color="white" size={iconSize} />
      </div>
      <p className="text-white mt-1" role="alert">
        {message}
      </p>
      {children}
    </div>
  </>
);

export default LockedOverlay;
